import request from 'utils/request';
import configs from 'configs';

const { commentServiceUrl } = configs;

export async function getComments(params) {
  return request({
    url: `${commentServiceUrl}/comments`,
    method: 'get',
    data: params,
  });
}

export async function addComment(params) {
  return request({
    url: `${commentServiceUrl}/comments`,
    method: 'post',
    data: params,
  });
}

export async function updateComment(params) {
  return request({
    url: `${commentServiceUrl}/comments/${params.id}`,
    method: 'put',
    data: params,
  });
}

export async function deleteComment(params) {
  return request({
    url: `${commentServiceUrl}/comments/${params.id}`,
    method: 'delete',
    data: params,
  });
}

export async function getCommentsInStream({ streamId, ...params }) {
  return request({
    url: `${commentServiceUrl}/streams/${streamId}/comments`,
    method: 'get',
    data: params,
  });
}

export async function statistic(params) {
  return request({
    url: `${commentServiceUrl}/statistic`,
    method: 'post',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/comment.js